module.exports = __webpack_public_path__ + "img/lontong-opor-ayam.9b79cddf.jpg";